
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 6 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.333 5.6a.325.325 0 00.236-.103.36.36 0 00.098-.247v-2.1a.36.36 0 00-.098-.247.325.325 0 00-.236-.103.325.325 0 00-.235.103A.36.36 0 002 3.15v2.1a.36.36 0 00.098.247.325.325 0 00.235.103zm3.334-4.2H4.333v-.35c0-.278-.105-.546-.293-.742A.976.976 0 003.333 0h-.666c-.266 0-.52.11-.707.308a1.077 1.077 0 00-.293.742v.35H.333a.325.325 0 00-.235.103A.36.36 0 000 1.75a.36.36 0 00.098.247.326.326 0 00.235.103h.334v3.85c0 .278.105.546.293.742A.976.976 0 001.667 7h2.666c.266 0 .52-.11.707-.308.188-.196.293-.464.293-.742V2.1h.334a.326.326 0 00.235-.103A.36.36 0 006 1.75a.36.36 0 00-.098-.247.325.325 0 00-.235-.103zm-3.334-.35a.36.36 0 01.098-.247A.326.326 0 012.667.7h.666c.089 0 .174.037.236.103a.36.36 0 01.098.247v.35H2.333v-.35zm2.334 4.9a.36.36 0 01-.098.247.325.325 0 01-.236.103H1.667a.325.325 0 01-.236-.103.36.36 0 01-.098-.247V2.1h3.334v3.85zm-1-.35a.325.325 0 00.235-.103A.36.36 0 004 5.25v-2.1a.36.36 0 00-.098-.247.325.325 0 00-.235-.103.325.325 0 00-.236.103.36.36 0 00-.098.247v2.1a.36.36 0 00.098.247.325.325 0 00.236.103z","fill":"#B8B8B8"}})])
          )
        }
      }
    